import { Injectable } from '@angular/core';
import { Slide, SlideTypes } from '../Type/okeeycash-slide.interface';

@Injectable({
  providedIn: 'root'
})
export class OkeeyCashSlideService {
  private _selectedIndex: number;

  constructor() {
    this._selectedIndex = 0;
  }

  public set selectedIndex(index: number) {
    this._selectedIndex = index;
  }

  public get selectedIndex(): number {
    return this._selectedIndex;
  }

  public addResizeEvent(callback: () => void): void {
    window.addEventListener('resize', callback);
  }

  public removeResizeEvent(callback: () => void): void {
    window.removeEventListener('resize', callback);
  }

  public manipulateSlides(slides: Slide[], slideTypes: { index: number; type: SlideTypes }[]): Slide[] {
    slideTypes.forEach(({ index, type }) => {
      slides = this.insertComponentAt(slides, index, type);
    });
    return slides;
  }

  private insertComponentAt(slides: Slide[], index: number, componentType: SlideTypes): Slide[] {
    if (!slides.some(slide => slide.type === componentType)) {
      if (index < slides.length) {
        slides.splice(index, 0, { type: componentType } as Slide);
      } else {
        slides.push({ type: componentType } as Slide);
      }
    }
    return slides;
  }
}
